import React from 'react';
import bonusStarsUrl from './teacherBonusStars.svg';
import '@fontsource/nunito/700.css';
import '@fontsource/nunito/900.css';
import './TeacherBonusCelebration.css';

// A single shared success scene for board and account teachers.
// Figures are decorative: numbers come from the verified award response, not the art.
export default function TeacherBonusCelebration({ count, amount }) {
  return <div className="pa-bonus-stage">
    <div className="pa-bonus-ambient" aria-hidden="true"><i /><i /><i /><i /><i /><i /></div>
    <div className="pa-bonus-eyebrow"><span aria-hidden="true">✦</span> ÖĞRETMEN BONUSU</div>
    <div className="pa-bonus-art" aria-hidden="true">
      <img src={bonusStarsUrl} className="pa-bonus-stars-svg" alt="" draggable="false" data-testid="pa-bonus-stars" />
      <span className="pa-bonus-art-amount">+{amount}</span>
    </div>
    <h2 id="pa-success-title" className="pa-bonus-title">Yaşasın, bonuslar geldi!</h2>
    <p className="pa-bonus-subline">Minik yıldızlar, kocaman mutluluk! <span aria-hidden="true">✨</span></p>
    <div className="pa-bonus-metrics" role="group" aria-label="Dağıtılan bonus">
      <div className="pa-bonus-metric pa-bonus-students">
        <strong className="pa-bonus-number">{count}</strong>
        <span className="pa-bonus-metric-label">öğrenciye bonus</span>
      </div>
      <div className="pa-bonus-metric pa-bonus-points">
        <strong className="pa-bonus-number">+{amount}</strong>
        <span className="pa-bonus-metric-label">kişi başı puan</span>
      </div>
    </div>
    <p id="pa-bonus-saved" className="pa-bonus-saved"><span aria-hidden="true">✓</span> Bonuslar başarıyla kaydedildi</p>
  </div>;
}
